<template>
  <span v-if="resultsStore?.getCurrentLang?.code === 'en'" class="def-price-en">
    <slot />
  </span>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
</script>

<style lang="scss" scoped>
.def-price-en {
  font-size: rem(11);
  line-height: 110%;
  color: var(--color-red);
  white-space: nowrap;
}
</style>
